import React from "react";
import { Button } from "../../../../controls";
import { action, API, controller } from "../../../../api/api";
import Processing from "../../../../layout/Processing";
import { useNavigate } from "react-router-dom";

const UploadProducts = ({
  values,
  setValues,
  setStatus,
  fileName,
  setProcessing,
  setAlert,
}) => {
  const navigate = useNavigate();
  const handleCancel = () => {
    setValues();
    setStatus();
  };

  function objectToFormData(obj, formData = new FormData(), parentKey = "") {
    if (Array.isArray(obj)) {
      obj.forEach((value, index) => {
        if (
          value !== null &&
          value !== "" &&
          (typeof value !== "object" || Object.keys(value).length > 0)
        ) {
          objectToFormData(value, formData, `${parentKey}[${index}]`);
        }
      });
    } else if (obj !== null && typeof obj === "object") {
      Object.keys(obj).forEach((key) => {
        if (
          obj[key] !== null &&
          obj[key] !== "" &&
          (typeof obj[key] !== "object" || Object.keys(obj[key]).length > 0)
        ) {
          const fullKey = parentKey ? `${parentKey}[${key}]` : key;
          objectToFormData(obj[key], formData, fullKey);
        }
      });
    } else if (parentKey && obj !== null && obj !== "") {
      formData.append(parentKey, obj);
    }
    return formData;
  }

  const handleSubmit = () => {
    setProcessing({ show: true, title: "Uploading products..." });
    API(controller.Product + action.UploadProducts).post(
      objectToFormData(values, new FormData(), "prods"),
      (res) => {
        setProcessing({ show: false });
        if (res && res.status === 200) {
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: res.msg,
            onClick: () => navigate("/products"),
          });
        } else if (res) {
          setAlert({
            isOpen: true,
            type: "error",
            title: "Internal Server Error",
            subTitle: res.msg,
          });
        } else console.warn("Error uploading products", res);
      }
    );
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center bg-white p-8 rounded-2xl shadow-xs max-w-lg mx-auto border border-gray-100">
        <Processing />
        <h2 className="text-2xl font-bold text-gray-600 mb-4 text-center">
          '{fileName}' is ready to upload.
        </h2>
        <p className="text-gray-600 mb-8 text-center">
          By continuing, you will import{" "}
          <span className="font-semibold text-gray-600">
            {values.length} products
          </span>
          .
        </p>
        <div className="flex flex-wrap gap-4 items-center justify-center">
          <Button
            onClick={handleCancel}
            size="large"
            variant="text"
            className="!min-w-[150px] "
          >
            Cancel Import
          </Button>
          <Button
            onClick={handleSubmit}
            size="large"
            className="!min-w-[150px]"
          >
            Continue with Import
          </Button>
        </div>
      </div>
    </>
  );
};

export default UploadProducts;
